<div class="tooltip-container">
   <ng-container *ngTemplateOutlet="templateRef"></ng-container>
</div>
